/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Reactivated_ToastInputs */

const cs_franchise_reactivated_toast = /** @type {(inputs: Franchise_Reactivated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licence obnovena`)
};

const en_franchise_reactivated_toast = /** @type {(inputs: Franchise_Reactivated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License reactivated`)
};

/**
* | output |
* | --- |
* | "License reactivated" |
*
* @param {Franchise_Reactivated_ToastInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_reactivated_toast = /** @type {((inputs?: Franchise_Reactivated_ToastInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Reactivated_ToastInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_reactivated_toast(inputs)
	return cs_franchise_reactivated_toast(inputs)
});